import { valueLabelFor } from '../intRangeChip.utils';
const BILLING_TIMINGS = [
    'upfront',
    'endOfCycle'
];
export const billingLimitTexts = (t)=>({
        valueIs: (value)=>typeof value === 'number' ? t.servicesBillingLimitTimes({
                count: value
            }) : t.servicesBillingLimitTimesBound({
                value
            }),
        valueIsNot: (value)=>t.servicesBillingLimitNotTimes({
                count: value
            }),
        valueOver: (value)=>t.servicesBillingLimitOver({
                value
            }),
        valueUnder: (value)=>t.servicesBillingLimitUnder({
                value
            }),
        label: t.servicesBillingLimitExistsLabel()
    });
export const billingLimitLabel = (limit, t)=>valueLabelFor(limit, billingLimitTexts(t));
export const billingTimingOf = (billUpfront)=>billUpfront ? 'upfront' : 'endOfCycle';
export const billUpfrontOf = (timing)=>timing == null ? undefined : timing === 'upfront';
const localizeBillingTiming = (t, timing)=>timing === 'upfront' ? t.servicesBillingTimingUpfront() : t.servicesBillingTimingEndOfCycle();
export const billingTimingLabel = (billUpfront, t)=>localizeBillingTiming(t, billingTimingOf(billUpfront));
export const billingTimingItems = (t)=>BILLING_TIMINGS.map((value)=>({
            value,
            label: localizeBillingTiming(t, value)
        }));
